// frontend/src/components/Common/ScrollToTop.jsx
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // 1. Force instant scroll on main window and document elements
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.body.scrollTo({ top: 0, left: 0, behavior: "instant" });

    // The admin shell owns scrolling; reset only the outlet container.
    const containers = document.querySelectorAll(
      ".main-content, .layout, .admin-content, #root",
    );
    containers.forEach((el) => {
      if (el) {
        el.scrollTop = 0;
      }
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
